<template>
  <v-row class="fill-height">
    <v-col cols="12" class="fill-height pb-0">
      <v-card class="fill-height chat-suggestions">
        <v-card-title class="justify-center pa-3">
          <p class="ma-auto">Chatbot</p>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text>
          <template v-for="(suggestion) of suggestions2">

            <v-list-item :key="suggestion.id">
              <v-list-item-avatar>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      @click="rejectSuggestion(suggestion)"
                      :disabled="sending || isDisconnected"
                      color="red"
                      v-on="on"
                    >
                      <v-icon>mdi-thumb-down</v-icon>
                    </v-btn>
                  </template>
                  <span>Reject Suggestion</span>
                </v-tooltip>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title style="white-space: break-spaces">{{ suggestion.message }}</v-list-item-title>

                <div class="orange--text">
                  <v-list-item-subtitle class="orange--text" v-if="suggestion.up_to_hand_num">Valid to Hand #{{ suggestion.up_to_hand_num }}</v-list-item-subtitle>
                  <v-list-item-subtitle class="orange--text" v-if="suggestion.up_to_ts">Valid for {{ Math.round(suggestion.up_to_ts - ((+(new Date()))/1000)) }}s</v-list-item-subtitle>
                </div>
              </v-list-item-content>

              <v-list-item-action>

                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      @click="sendText(suggestion)"
                      :disabled="sending || isDisconnected"
                      color="green"
                      v-on="on"
                    >
                      <v-icon>mdi-thumb-up</v-icon>
                    </v-btn>
                  </template>
                  <span>Approve and Send</span>
                </v-tooltip>

              </v-list-item-action>

            </v-list-item>
            <v-divider :key="'divider-' + suggestion.id"></v-divider>

          </template>

        </v-card-text>
      </v-card>
    </v-col>

    <reject-suggestion
      ref="rejectSuggestionDialog"
    ></reject-suggestion>

  </v-row>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import RejectSuggestion from "./RejectSuggestion";

export default {
  name: "ChatbotSuggestions",

  components: {
    RejectSuggestion,
  },

  data() {
    return {
      pressed: false,
      sending: false
    }
  },

  computed: {
    suggestions2() {
      return this.chatbotSuggestions(this.activeChatAccountName);
    },

    ...mapGetters([
        "activeChatAccountName",
        "chatbotSuggestions",
        "isDebug",
    ]),
    ...mapState([
        "isDisconnected",
    ]),
  },

  mounted() {
    window.addEventListener("keydown", (e) => {
      if (e.ctrlKey) {
        this.pressed = true;
      }
    })
    window.addEventListener("keyup", () => {
      this.pressed = false;
    })
  },

  methods: {
    sendText(suggestion) {
      if (this.sending) return;

      this.sending = true;

      // add pending message
      this.$store.dispatch("addPendingMessage", {
        'displayID': this.activeChatAccountName,
        'type': 'pending_chat',
        'name': this.activeChatAccountName,
        'text': suggestion.message.trim(),
        'ts': new Date(),
      });

      // send the chat
      this.$socket.emit("send_chat", {
        suggestion2_id: suggestion.id,
        displayID: this.activeChatAccountName,
        text: suggestion.message.trim()
      });

      // mark suggestion as sent

      setTimeout(() => {
        this.sending = false;
      }, 2000);
    },

    rejectSuggestion(suggestion) {
      this.$refs.rejectSuggestionDialog.open(suggestion);
    },
  }
}
</script>

<style scoped>
.chat-suggestions {
  overflow-y: auto;
}

.chat-suggestions > div {
  padding: 0;
}
</style>
